import { useCart } from "@/context/CartContext";
import { Link, useNavigate } from "react-router-dom";
import { Trash2, Minus, Plus } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function Cart() {
  const { items, remove, update, total } = useCart();
  const { t } = useLang();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <h1 className="text-4xl">{t("Your bazaar bag is empty")}</h1>
        <p className="mt-4 text-[#4A5568]">{t("Discover handmade treasures from across India.")}</p>
        <Link to="/products" className="mt-8 inline-block btn-primary">{t("Start shopping")}</Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-6 py-12 grid lg:grid-cols-3 gap-10">
      <div className="lg:col-span-2">
        <h1 className="text-4xl mb-8">{t("Your cart")}</h1>
        <div className="space-y-4">
          {items.map((it) => (
            <div key={it.id} className="card-flat p-4 flex gap-4 items-center" data-testid={`cart-item-${it.id}`}>
              <div className="w-20 h-20 rounded-lg bg-[#F2EFEB] overflow-hidden shrink-0">
                {it.image && <img src={it.image} alt={it.title} className="w-full h-full object-cover" />}
              </div>
              <div className="flex-1">
                <Link to={`/product/${it.id}`} className="font-serif text-lg text-[#13294B] hover:text-[#E25A24]">{it.title}</Link>
                <div className="text-xs text-[#718096]">by {it.vendor_name}</div>
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => update(it.id, it.quantity - 1)} className="w-8 h-8 rounded-full border border-[#E2DCD0] grid place-items-center hover:bg-[#F2EFEB]">
                  <Minus className="w-3 h-3" />
                </button>
                <span data-testid={`cart-qty-${it.id}`} className="w-6 text-center font-semibold">{it.quantity}</span>
                <button onClick={() => update(it.id, it.quantity + 1)} className="w-8 h-8 rounded-full border border-[#E2DCD0] grid place-items-center hover:bg-[#F2EFEB]">
                  <Plus className="w-3 h-3" />
                </button>
              </div>
              <div className="w-24 text-right font-bold">₹{(it.price * it.quantity).toLocaleString('en-IN')}</div>
              <button onClick={() => remove(it.id)} data-testid={`cart-remove-${it.id}`} className="p-2 text-[#718096] hover:text-[#E25A24]">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
      <div>
        <div className="card-flat p-6 sticky top-24">
          <div className="label-caps mb-4">{t("Order summary")}</div>
          <div className="flex justify-between text-sm mb-2"><span className="text-[#4A5568]">{t("Subtotal")}</span><span className="font-semibold">₹{total.toLocaleString('en-IN')}</span></div>
          <div className="flex justify-between text-sm mb-2"><span className="text-[#4A5568]">{t("Shipping")}</span><span className="font-semibold text-[#275F36]">{t("Free")}</span></div>
          <div className="my-4 divider-warp" />
          <div className="flex justify-between items-end">
            <span className="text-sm text-[#4A5568]">{t("Total")}</span>
            <span data-testid="cart-total" className="text-2xl font-bold">₹{total.toLocaleString('en-IN')}</span>
          </div>
          <button data-testid="checkout-btn" onClick={() => navigate("/checkout")} className="mt-6 w-full btn-primary">{t("Checkout")}</button>
        </div>
      </div>
    </div>
  );
}
